import { useContext } from 'react'
import ReportPersonaContext from '../../../../../StateManagment/ReportPersonaContext'
import { TemplateDataContext } from '../../context/TemplateDataContext'
import isTemplateMode from './isTemplateMode'

// AI-CONTEXT: See docs/features/livereport-per-deelnemer.md
// Tegenhanger van useWidgetPeriod: de deelnemer van het rapport voor één
// widget. Centraal zodat de datawidgets niet elk de context lezen, de lege
// waarden gelijktrekken en de sjabloonmodus nalopen.

/**
 * De deelnemer (PersonaID) waarop een widget zijn gegevens filtert.
 *
 * Contract: een niet-lege string = filter op deze deelnemer; `null` = geen
 * deelnemer, toon alles zoals een gewoon rapport. `undefined`, `''` en alleen
 * spaties op het rapport worden `null`. In sjabloonmodus altijd `null`: de
 * gegevens komen dan van de sjabloonorganisatie, waar deze deelnemer niet
 * bestaat (AI-CONTEXT: See docs/pitfalls.md#state-firestore-lookup-empty-in-template-mode).
 *
 * Geef `null` NIET als waarde aan een `.where('PersonaID', '==', …)`: `null` is
 * daar een echte zoekwaarde en vindt alleen documenten zonder deelnemer
 * (docs/pitfalls.md#database-firestore-null-is-a-valid-query-value). Laat het
 * filter weg. En maak er ook geen `''` van: dat is het 'nog niet geladen'-teken
 * van de hooks en slaat de hele query over
 * (docs/pitfalls.md#database-empty-string-is-a-real-stored-value).
 *
 * @returns {string|null}
 */
const useWidgetPersona = () => {
    const personaId = useContext(ReportPersonaContext)
    const { isTemplate } = useContext(TemplateDataContext)

    if (isTemplate || isTemplateMode()) return null
    if (typeof personaId !== 'string' || personaId.trim() === '') return null
    return personaId
}

export default useWidgetPersona
